import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { X } from "lucide-react";

export default function FabricCompare() {
  const [fabrics, setFabrics] = useState([]);
  const [selected, setSelected] = useState([]);
  useEffect(() => { api.get("/products?category=fabric&limit=40").then(({ data }) => setFabrics(data.items)); }, []);
  const add = (f) => setSelected((s) => (s.find((x) => x.id === f.id) || s.length >= 4 ? s : [...s, f]));
  const rem = (id) => setSelected((s) => s.filter((x) => x.id !== id));
  return (
    <main className="sq-container py-12" data-testid="compare-page">
      <div className="sq-eyebrow">Side by side</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Compare Fabrics</h1>
      <p className="text-[#4B5563] mt-3 max-w-xl">Add up to 4 fabrics to see composition, weave and price side by side.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
        {selected.map((f) => (
          <div key={f.id} className="border border-squire-jeans" data-testid={`compare-${f.id}`}>
            <div className="relative">
              <img src={f.images?.[0]} alt={f.name} className="w-full aspect-[3/4] object-cover" />
              <button onClick={() => rem(f.id)} className="absolute top-2 right-2 bg-white p-1"><X size={14} /></button>
            </div>
            <div className="p-3 space-y-1 text-sm">
              <div className="font-display text-lg">{f.name}</div>
              <div><span className="sq-eyebrow text-[10px]">Type</span> {f.fabric_type}</div>
              <div><span className="sq-eyebrow text-[10px]">Comp</span> {f.composition || "—"}</div>
              <div><span className="sq-eyebrow text-[10px]">Care</span> {f.care || "—"}</div>
              <div><span className="sq-eyebrow text-[10px]">Price</span> {formatINR(f.price)} / m</div>
            </div>
          </div>
        ))}
        {Array.from({ length: Math.max(0, 4 - selected.length) }).map((_, i) => (
          <div key={i} className="border border-dashed border-black/20 aspect-[3/4] flex items-center justify-center text-[#4B5563] text-xs">Add fabric</div>
        ))}
      </div>

      <h3 className="sq-eyebrow mt-12">Pick fabrics</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
        {fabrics.map((f) => (
          <button key={f.id} data-testid={`compare-add-${f.id}`} onClick={() => add(f)} className="group text-left">
            <img src={f.images?.[0]} alt={f.name} className="w-full aspect-[3/4] object-cover group-hover:opacity-80" />
            <div className="font-display mt-2">{f.name}</div>
            <div className="sq-eyebrow">{formatINR(f.price)}/m</div>
          </button>
        ))}
      </div>
    </main>
  );
}
